export default "__VITE_ASSET__DMmSk13U__"